/**
 * Messages de l'authentification
 */

module.exports = {

    legalFiles: {
        termsOfUse: {
            label: 'CGU',
            altLabel: 'Consulter les conditions générales d\'utilisation.'
        },
        privacyPolicy: {
            label: 'Politique de confidentialité',
            altLabel: 'Consulter la politique de confidentialité'
        }
    },

    activation: {
        sendMail: {
            button: {
                label: 'Me le renvoyer'
            }
        }
    },

    // Page d'authentification
    login: {
        form: {
            title: 'Se connecter',
            register: {
                call: 'Nouveau sur la plateforme ?',
                button: {
                    label: 'Créer un compte'
                }
            },
            genericError: 'Une erreur s\'est produite pendant votre authentification.',
            registrationValidationError: 'Vous avez dû recevoir un mail de validation de votre inscription. Si ce n\'est pas le cas, cliquez <a href="{ url }" title="">ici</a> pour le recevoir à nouveau.',
            fields: {
                email: {
                    label: 'Adresse email'
                },
                password: {
                    label: 'Mot de passe'
                },
                rememberMe: {
                    label: 'Se souvenir de moi'
                },
                submit: {
                    label: 'Se connecter'
                }
            },
            accountValidationRequired: 'Connectez-vous à votre compte pour l\'activer.',
            fromInitPassword: 'Votre mot de passe a été initialisé. Vous pouvez l\'utiliser pour vous connecter.',
            fromResetPassword: 'Votre mot de passe a été réinitialisé. Vous pouvez l\'utiliser pour vous connecter.',
            fromRegistrationValidationRequest: 'Un mail de validation de votre inscription a été envoyé à l\'adresse { email }.',
            fromRemoveAccount: 'Votre compte vient d\'être supprimé.'
        },
        anchors: {
            forgotPassword: {
                label: 'Mot de passe oublié'
            }
        }
    },

    // Page d'inscription
    register: {
        registered: {
            title: 'Merci de vérifier votre e-mail en cliquant sur le lien qui vous a été envoyé à l\'adresse { email }',
            advice: 'Pensez à consulter vos spams ou l\'onglet "Promotions" ou "Notifications" de votre Gmail.',
            withoutNotification: 'Vous n\'avez-pas reçu l\'e-mail ?',
            sendActivationMail: {
                success: 'Un mail a été envoyé à l\'adresse { email }.',
                error: 'Une erreur s\'est produite pendant l\'envoi du mail.'
            }
        },

        loading: {
            resources: {
                error: 'Une erreur s\'est produite pendant le chargement de la configuration.'
            }
        },
        form: {
            title: 'Créer un compte',
            login: {
                call: 'Vous bénéficiez déjà d\'un compte ?',
                button: {
                    label: 'Se connecter'
                }
            },
            error: 'Une erreur s\'est produite pendant la création de votre compte.',
            // success: 'Votre compte a été créé. Un mail a été envoyé à l\'adresse { email }. Veuillez suivre le lien dans le mail pour activer votre compte.',
            fields: {
                firstName: 'Prénom',
                lastName: 'Nom',
                email: 'Adresse email pro',
                phone: 'Numéro de téléphone',
                societyName: 'Nom de l\'établissement',
                activitySector: 'Secteur d\'activité et métier',
                password: 'Mot de passe',
                passwordConfirmation: 'Confirmation de votre mot de passe',
                siteUrl: 'Site internet',
                country: 'Pays de résidence',
                timeZone: 'Fuseau Horaire',
                applicationLang: 'Langue de l\'interface',
                automaticVisibleTasks: 'Publications automatiquement affichées au client',
                termsOfUse: 'J\'ai lu et j\'accepte les <a href="{ termsOfUseUrl }" title="">Conditions Générales d\'Utilisation</a>',
                privacyPolicy: 'J\'ai lu et j\'accepte la <a href="{ privacyPolicyUrl }" title="">Politique de Confidentialité</a>',
                submit: 'Créer un compte'
            },

            description: {
                siteUrl: 'Nous pourrons ainsi récupérer vos informations et vous faire gagner du temps',
                termsOfUse: 'J\'ai lu et j’accepte les Conditions Générales d’Utilisation de { applicationName }. J\'accepte que les informations saisies soient exploitées, dans le cadre d\'une relation commerciale et de communication, par { applicationName }. En validant le formulaire, vous acceptez que { applicationName } mémorise et utilise votre adresse e-mail, votre téléphone et autres informations dans le but de vous contacter.'
            },

            placeholder: {
                siteUrl: 'https://www.url-monsite.com'
            },

            introduction: {
                title: 'Félicitation et très heureux de vous voir parmi nous 🥳',
                error: 'Une erreur s\'est produite pendant l\'enregistrement.',
                button: {
                    next: 'Go !' // Forcément un point d'exclamation
                }
            },

            society: {
                title: 'Informations essentielles',
                description: 'Pour comprendre votre activité et réaliser les meilleures publications 😀',
                error: 'Une erreur s\'est produite pendant l\'enregistrement des informations de votre entreprise.',
                fields: {
                    commercialName: 'Nom commercial',
                    siret: 'SIRET',
                    name: 'Nom de la société',
                    summary: 'Résumé de l\'activité',
                    siteUrl: 'Site internet',
                    workforce: 'Nombre de personnes',
                    activityType: 'Type d\'activité',
                    sector: 'Secteur d\'activité et métier'
                },
                descriptions: {
                    summary: 'Décrivez précisément votre activité et les cibles que vous souhaitez viser.'
                }
            },
            editorialLine: {
                title: 'Ligne éditoriale',
                description: 'Pour dialoguer avec votre audience, vous êtes plutôt :',
                error: 'Une erreur s\'est produite pendant l\'enregistrement de votre ligne éditoriale.'
            },
            graphicLine: {
                title: 'Ligne graphique',
                description: 'Vous aurez la possibilité de les uploader ultérieurement dans la rubrique "Mon profil"',
                error: 'Une erreur s\'est produite pendant l\'enregistrement de votre charte graphique.'
            },
            notifications: {
                title: 'Notifications & Communication',
                contentTitle: 'Une dernière information importante',
                description: 'Comment souhaitez-vous que nous communiquions avec vous ? C’est très important, vous allez recevoir des notifications pour valider les publications et il faudra être réactif 😀. Choisissez le ou les modes de fonctionnement qui sont les plus pratiques et agréables pour vous.',
                information: 'Vous aurez la possibilité de les modifier ultérieurement dans la rubrique "Mon profil".',
                error: 'Une erreur s\'est produite pendant l\'enregistrement de vos préférences de notifications.'
            },
            socialNetwork: {
                title: 'Informations essentielles',
                description: 'Connectez vos réseaux !',
                validateError: 'Vous devez lier au moins un réseau à votre compte.'
            }
        },
        confirmation: {
            description: 'Le champ "Site Internet" n\'est pas complété. Si vous disposez d\'un site web, indiquez l\'url. Il vous fera gagner du temps à l\'inscription. <br /><br />Sinon, vous pouvez créer un compte sans site web, des questions additionnelles vous seront posées pour comprendre votre activité.',
            button: {
                confirm: {
                    label: 'Je continue sans site web',
                },
                cancel: {
                    label: 'J\'indique l\'url de mon site'
                }
            }
        }
    },

    // Page de mot de passe oublié
    forgotPassword: {
        form: {
            title: 'Mot de passe oublié',
            genericError: 'Une erreur s\'est produite pendant le traitement de votre demande.',
            fields: {
                email: {
                    label: 'Adresse email'
                },
                submit: {
                    label: 'Recevoir le lien de réinitialisation'
                }
            },
            success: 'Un email pour réinitialiser votre mot de passe a été envoyé à l\'adresse { email }.'
        },
        anchors: {
            login: {
                label: 'Revenir à la connexion'
            }
        }
    },

    // Page de réinitialisation de mot de passe
    resetPassword: {
        form: {
            title: 'Réinitialisation de mot de passe',
            genericError: 'Une erreur s\'est produite pendant la réinitialisation de votre mot de passe.',
            fields: {
                email: {
                    label: 'Adresse email'
                },
                password: {
                    label: 'Mot de passe'
                },
                passwordConfirmation: {
                    label: 'Confirmation du mot de passe'
                },
                submit: {
                    label: 'Mise à jour du mot de passe'
                }
            }
        }
    },

    // Page d'initialisation de mot de passe
    initPassword: {
        form: {
            title: 'Initialisation du mot de passe',
            genericError: 'Une erreur s\'est produite pendant l\'initialisation de votre mot de passe.',
            fields: {
                password: {
                    label: 'Mot de passe'
                },
                passwordConfirmation: {
                    label: 'Confirmation du mot de passe'
                },
                submit: {
                    label: 'Initialisation du mot de passe'
                }
            }
        }
    }

};
